/* eslint-disable @typescript-eslint/no-empty-function */
import { serviceProductTree } from '@/service';
import { useGlobal } from '@/utils/useGlobal';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import EfImg from '@elem/ui/ef-img';
import { getIsPadWidth } from '@elem/utils/devices';
import { Input, message, Select, Tabs, Tooltip } from 'antd';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { ICON_DONE, ICON_MORE, SUPPORT_CASE_TYPE } from '../index';

const { TextArea } = Input;

const TooltipIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
                d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
                stroke="#707070"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M8 9.33342V4.66675" stroke="#707070" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8 11.3333H8.00667" stroke="#707070" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default function Step2({ caseData, step, onChangeStep, onChangeCase }: any) {
    const { useLang } = useGlobal();
    const { locale = 'us' } = useRouter();
    const { t } = useLang('supportcasecreate');
    const [catagoryList, setCatagoryList] = useState<any>([]);
    const [showTips, setShowTips] = useState<any>(false);
    const [selectedScenario, setSelectedScenario] = useState('');
    const [selectedOption, setSelectedOption] = useState(''); // 添加新的状态来控制选项

    const scenarios = [
        {
            title: 'Home Backup Power',
            desc: 'Stay powered through any outage with reliable home backup solutions.',
            image: 'https://websiteoss.ecoflow.com/upload/image/1747109250513/Home%20Backup%20Power.jpg',
        },
        {
            title: 'On-the-Road',
            desc: 'Power your road trips with portable, plug-and-play energy solutions.',
            image: 'https://websiteoss.ecoflow.com/upload/image/1747109250714/On-the-Road.jpg',
        },
        {
            title: 'Power for the Outdoors',
            desc: 'From one-day hikes to week-long escapes, stay powered with off-grid solar and battery solutions.',
            image: 'https://websiteoss.ecoflow.com/upload/image/1747109250328/Power%20for%20the%20Outdoors.jpg',
        },
    ];
    /**
     * 回到上一步，提示未保存框，确认后，则清空当前步骤的数据 TODO
     *
     * caseTypeCode 4
     * 只有 productModel
     *
     * caseTypeCode 5
     * productModel
     * orderNo
     * purchaseChannel
     * customerAddress
     *
     * caseTypeCode 6
     * productModel
     * sn
     * customerAddress
     *
     * caseTypeCode 7
     * 无此步
     */
    const getProductTree = async () => {
        try {
            const res: any = await serviceProductTree(locale);
            if (res?.code == '0') {
                const list: any = [];
                res.data?.forEach((item: any) => {
                    const catagory = { id: item.productCatagoryId, catagoryName: item.productCatagoryName, seriesList: [] };
                    const seriesList: any = [];
                    item.spuList?.forEach((serie: any) => {
                        const series = { id: serie.productCatagoryId, serieName: serie.productCatagoryName, productList: [] };
                        let productList = [];
                        if (serie.spuList) {
                            productList = serie.spuList?.map((spu: any) => {
                                const parsedImages = JSON.parse(spu.images);
                                return {
                                    id: spu.spuId,
                                    productName: spu.spuName,
                                    img: parsedImages.transparentImages || parsedImages.images || parsedImages.navigatorImages,
                                };
                            });
                            series.productList = productList;
                            seriesList.push(series);
                        } else {
                            const parsedImages = JSON.parse(serie.images);
                            const product = {
                                id: serie.spuId,
                                productName: serie.spuName,
                                img: parsedImages.transparentImages || parsedImages.images || parsedImages.navigatorImages,
                            };
                            seriesList.push(product);
                        }
                    });
                    catagory.seriesList = seriesList;
                    list.push(catagory);
                });
                setCatagoryList(list);
            } else {
                message.error(res.message);
            }
        } catch (e) {}
    };

    const option = [
        { value: 'Amazon', label: 'Amazon' },
        { value: 'eBay', label: 'eBay' },
        { value: 'Walmart', label: 'Walmart' },
        { value: 'Costco', label: 'Costco' },
        { value: 'Yahoo', label: 'Yahoo' },
        { value: 'Home Depot', label: 'Home Depot' },
        { value: 'Wellbots', label: 'Wellbots' },
        { value: 'Best_Buy', label: 'Best Buy' },
        { value: 'Earthtech Products', label: 'Earthtech Products' },
        { value: 'HSN', label: 'HSN' },
        { value: 'QVC', label: 'QVC' },
        { value: 'Lazada', label: 'Lazada' },
        { value: 'Shopee', label: 'Shopee' },
        { value: 'Aliexpress', label: 'Aliexpress' },
        { value: 'Official Website', label: 'Official Website' },
        { value: 'Rakuten', label: 'Rakuten' },
        { value: 'Manomano', label: 'Manomano' },
        { value: 'Kaulfland', label: 'Kaulfland' },
        { value: 'Cdiscount', label: 'Cdiscount' },
        { value: 'TikTok', label: 'TikTok' },
        { value: 'Reddit', label: 'Reddit' },
        { value: 'Newegg', label: 'Newegg' },
        { value: 'wayfair', label: 'wayfair' },
        { value: 'TEMU', label: 'TEMU' },
        { value: 'KOL', label: 'KOL' },
        { value: 'Others', label: 'Others' },
    ];

    const isShow = caseData.caseTypeCode === SUPPORT_CASE_TYPE['Pre-sales'] && ['us', 'ca'].includes(locale);
    const handleOptionChange = (option: 'scenario' | 'product') => {
        setSelectedOption(option);
        setSelectedScenario('');
        onChangeCase({ usageScenario: '', skuId: '', productModel: '' });
    };

    const checkDisabled = () => {
        if (caseData.productModel || caseData.skuId || caseData.usageScenario) {
            if (caseData.caseTypeCode == SUPPORT_CASE_TYPE['Pre-sales']) {
                return true;
            } else if (caseData.caseTypeCode == SUPPORT_CASE_TYPE['Order']) {
                if (caseData.orderNo && caseData.purchaseChannel && caseData.customerAddress) {
                    return true;
                }
            } else if (caseData.caseTypeCode == SUPPORT_CASE_TYPE['Technical']) {
                if (caseData.sn && caseData.sn.length > 14 && caseData.customerAddress) {
                    return true;
                }
            }
        }
        return false;
    };

    const onNext = () => {
        /**
         * caseTypeCode 4
         * 只有 productModel
         *
         * caseTypeCode 5
         * productModel
         * orderNo
         * purchaseChannel
         * customerAddress
         *
         * caseTypeCode 6
         * productModel
         * sn
         * customerAddress
         */
        setShowTips(true);
        if (caseData.productModel || caseData.skuId || caseData.usageScenario) {
            if (caseData.caseTypeCode == SUPPORT_CASE_TYPE['Pre-sales']) {
                onChangeStep('step3');
            } else if (caseData.caseTypeCode == SUPPORT_CASE_TYPE['Order']) {
                if (caseData.orderNo && caseData.purchaseChannel && caseData.customerAddress) {
                    onChangeStep('step3');
                }
            } else if (caseData.caseTypeCode == SUPPORT_CASE_TYPE['Technical']) {
                if (caseData.sn.length < 17 && caseData.sn.length > 14 && caseData.customerAddress) {
                    onChangeStep('step3');
                }
            }
        }
    };

    useEffect(() => {
        getProductTree();
    }, []);

    return (
        <div className="step step2">
            <div className="left">
                <div className="icon">
                    <div className="icon">{step?.step3 ? <ICON_DONE /> : <p className="number">2</p>}</div>
                </div>
                <div className="text">
                    <div className="step-title">{t('step2')}</div>
                    {step?.step3 && (
                        <button onClick={() => onChangeStep('step2', { ...caseData, customerContent: '', annotationUrls: [], recaptchaResponse: '' })}>
                            {t('edit')}
                        </button>
                    )}
                </div>
            </div>
            <div className="form">
                {step?.step3 && (
                    <div className="text-pane">
                        <p className="title">{caseData.productModel || caseData.usageScenario}</p>
                        {caseData.caseTypeCode == SUPPORT_CASE_TYPE['Order'] && (
                            <>
                                <p className="detail top">
                                    {t('step2_model_2_label')}: {caseData.orderNo}
                                </p>
                                <p className="detail">
                                    {t('step2_model_3_label')}: {caseData.purchaseChannel}
                                </p>
                                <p className="detail">
                                    {t('step2_model_4_label')}: {caseData.customerAddress}
                                </p>
                            </>
                        )}
                        {caseData.caseTypeCode == SUPPORT_CASE_TYPE['Technical'] && (
                            <>
                                <p className="detail top">
                                    {t('step2_model_2_sn_label')}: {caseData.sn}
                                </p>
                                <p className="detail">
                                    {t('step2_model_4_label')}: {caseData.customerAddress}
                                </p>
                            </>
                        )}
                    </div>
                )}
                {!step?.step3 && (
                    <>
                        {isShow && (
                            <div className="selection-options">
                                <div className={`option-item ${selectedOption === 'scenario' ? 'active' : ''}`} onClick={() => handleOptionChange('scenario')}>
                                    <input type="radio" checked={selectedOption === 'scenario'} onChange={() => {}} />
                                    <span>Select Scenario</span>
                                </div>
                                <div className={`option-item ${selectedOption === 'product' ? 'active' : ''}`} onClick={() => handleOptionChange('product')}>
                                    <input type="radio" checked={selectedOption === 'product'} onChange={() => {}} />
                                    <span>Select Product</span>
                                </div>
                            </div>
                        )}
                        {/* 场景选择内容区域 */}
                        {selectedOption === 'scenario' && isShow && (
                            <div className="scenario-selection">
                                <div className="scenario-list">
                                    {scenarios.map((item, index) => (
                                        <div
                                            key={index}
                                            className={`scenario-item ${selectedScenario === item.title ? 'active' : ''}`}
                                            onClick={() => {
                                                setSelectedScenario(item.title);
                                                onChangeCase({ usageScenario: item.title });
                                            }}
                                        >
                                            <div className="scenario-image">
                                                <img src={item.image} alt={item.title} />
                                            </div>
                                            <div className="scenario-content">
                                                <h4>{item.title}</h4>
                                                <p>{item.desc}</p>
                                            </div>
                                            <div className="scenario-radio">
                                                <input type="radio" checked={selectedScenario === item.title} onChange={() => {}} />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                        {/* 原有的产品选择部分 */}
                        {(selectedOption === 'product' || !['us', 'ca'].includes(locale) || caseData.caseTypeCode !== SUPPORT_CASE_TYPE['Pre-sales']) && (
                            <Tabs className="model-content" onChange={(val) => onChangeCase({ skuId: '', productModel: '' })}>
                                <Tabs.TabPane tab={t('step2_tab_select')} key="select">
                                    <Tabs className="catagory-content" moreIcon={<ICON_MORE />}>
                                        {catagoryList?.map((catagory: any) => (
                                            <Tabs.TabPane tab={catagory.catagoryName} key={catagory.id}>
                                                {catagory.seriesList[0]?.serieName && (
                                                    <Tabs className="series-content" moreIcon={<ICON_MORE />}>
                                                        {catagory.seriesList?.map((series: any) => (
                                                            <Tabs.TabPane tab={series.serieName} key={series.id}>
                                                                {series.productList?.map((product: any) => (
                                                                    <div
                                                                        className={`product ${product.id == caseData.skuId ? 'active' : ''}`}
                                                                        key={product.id}
                                                                        onClick={() => onChangeCase({ skuId: product.id, productModel: product.productName })}
                                                                    >
                                                                        <EfImg className="img" pc={product.img} />
                                                                        <p className="name">{product.productName}</p>
                                                                    </div>
                                                                ))}
                                                            </Tabs.TabPane>
                                                        ))}
                                                    </Tabs>
                                                )}
                                                {!catagory.seriesList[0]?.serieName &&
                                                    catagory.seriesList?.map((product: any) => (
                                                        <div
                                                            className={`product ${product.id == caseData.skuId ? 'active' : ''}`}
                                                            key={product.id}
                                                            onClick={() => onChangeCase({ skuId: product.id, productModel: product.productName })}
                                                        >
                                                            <EfImg className="img" pc={product.img} />
                                                            <p className="name">{product.productName}</p>
                                                        </div>
                                                    ))}
                                            </Tabs.TabPane>
                                        ))}
                                    </Tabs>
                                </Tabs.TabPane>
                                <Tabs.TabPane tab={t('step2_tab_input')} key="input" className="tabpanel-step2">
                                    <div className="product-model row">
                                        <p className="label">{t('step2_model_1_label')}</p>
                                        <TextArea
                                            className={!showTips || caseData.productModel ? '' : 'error'}
                                            size="large"
                                            rows={1}
                                            placeholder={t('step2_model_1_placeholder')}
                                            maxLength={50}
                                            showCount
                                            value={caseData.productModel}
                                            onChange={(e) => onChangeCase({ productModel: e.target.value })}
                                        />
                                        {showTips && !caseData.productModel && (
                                            <p className="error-tips">
                                                <ExclamationCircleOutlined />
                                                {t('step2_model_1_error_tips')}
                                            </p>
                                        )}
                                    </div>
                                </Tabs.TabPane>
                            </Tabs>
                        )}
                        <div className="common-form">
                            {SUPPORT_CASE_TYPE['Order'] == caseData.caseTypeCode && (
                                <>
                                    <div className="order-number row">
                                        <p className="title purchase">{t('step2_model_purchase')}</p>
                                        <p className="label">{t('step2_model_2_label')}</p>
                                        <TextArea
                                            className={!showTips || caseData.orderNo ? '' : 'error'}
                                            size="large"
                                            rows={1}
                                            placeholder={t('step2_model_2_placeholder')}
                                            maxLength={50}
                                            showCount
                                            value={caseData.orderNo}
                                            onChange={(e) => onChangeCase({ orderNo: e.target.value })}
                                        />
                                        {showTips && !caseData.orderNo && (
                                            <p className="error-tips">
                                                <ExclamationCircleOutlined />
                                                {t('step2_model_2_error_tips')}
                                            </p>
                                        )}
                                    </div>
                                    <div className="purchase-channel row">
                                        <p className="label">{t('step2_model_3_label')}</p>
                                        <Select
                                            size="large"
                                            dropdownMatchSelectWidth
                                            style={{ width: getIsPadWidth() ? '100%' : 678 }}
                                            placeholder={t('step2_model_3_placeholder')}
                                            options={option}
                                            value={caseData.purchaseChannel}
                                            onChange={(value: string) => onChangeCase({ purchaseChannel: value })}
                                        />
                                        {showTips && !caseData.purchaseChannel && (
                                            <p className="error-tips">
                                                <ExclamationCircleOutlined />
                                                {t('step2_model_3_error_tips')}
                                            </p>
                                        )}
                                    </div>
                                </>
                            )}
                            {SUPPORT_CASE_TYPE['Technical'] == caseData.caseTypeCode && (
                                <div className="sn row">
                                    <p className="title purchase">{t('step2_model_purchase')}</p>
                                    <div className="label">
                                        {t('step2_model_2_sn_label')}
                                        <Tooltip
                                            overlayInnerStyle={{
                                                borderRadius: '4px',
                                                padding: 10,
                                                fontFamily: 'var(--ff-woff2-M)',
                                                fontSize: 12,
                                                lineHeight: 1.3,
                                            }}
                                            color="#0000005"
                                            title={t('step2_model_2_sn_label_tips')}
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <TooltipIcon />
                                            </div>
                                        </Tooltip>
                                    </div>
                                    <TextArea
                                        className={caseData.sn && caseData.sn.length < 15 ? 'error' : ''}
                                        size="large"
                                        rows={1}
                                        placeholder={t('step2_model_2_sn_placeholder')}
                                        maxLength={16}
                                        showCount
                                        value={caseData.sn}
                                        onChange={(e) => onChangeCase({ sn: e.target.value })}
                                    />
                                    {caseData.sn && caseData.sn.length < 15 && (
                                        <p className="error-tips">
                                            <ExclamationCircleOutlined />
                                            {t('step2_model_2_sn_error_tips')}
                                        </p>
                                    )}
                                </div>
                            )}
                            {[SUPPORT_CASE_TYPE['Order'], SUPPORT_CASE_TYPE['Technical']].includes(caseData.caseTypeCode) && (
                                <div className="detailed-address row">
                                    <p className="label">{t('step2_model_4_label')}</p>
                                    <TextArea
                                        className={!showTips || caseData.customerAddress ? '' : 'error'}
                                        size="large"
                                        rows={10}
                                        placeholder={t('step2_model_4_placeholder')}
                                        maxLength={100}
                                        showCount
                                        value={caseData.customerAddress}
                                        onChange={(e) => onChangeCase({ customerAddress: e.target.value })}
                                    />
                                    {showTips && !caseData.customerAddress && (
                                        <p className="error-tips">
                                            <ExclamationCircleOutlined />
                                            {t('step2_model_4_error_tips')}
                                        </p>
                                    )}
                                </div>
                            )}
                        </div>
                        <button
                            className="btn-next"
                            // 判断两种model
                            disabled={!checkDisabled()}
                            onClick={() => onNext()}
                            style={{
                                display: isShow && !selectedOption ? 'none' : 'block',
                            }}
                        >
                            {t('btn_next')}
                        </button>
                    </>
                )}
            </div>
        </div>
    );
}
